import { z } from 'zod';
/** Stable catalog identifiers; reject rather than silently trim or change case. */
export const SUBJECT_CODE_PATTERN = /^[A-Z]{3,}$/;
// JavaScript's $ can match before a trailing newline; require the whole value too.
export const subjectCode = z
    .string()
    .refine((code) => SUBJECT_CODE_PATTERN.exec(code)?.[0] === code, {
    message: 'Subject codes must contain at least 3 uppercase ASCII letters (A–Z) only.',
});
//# sourceMappingURL=subject-code.js.map